/**
 * @file useAgreement.js
 * @description 协议弹窗：按 code 拉取 HTML 并消毒后展示
 * @module features/comic/composables/useAgreement
 */

import { ref } from 'vue'
import { registerAgreementOpener } from '@/shared/utils/payDialogBridge'
import { sanitizeAgreementHtml } from '@/shared/utils/sanitizeHtml'
import { fetchAgreementDetailApi } from '../api/agreementApi'

const visible = ref(false)
const loading = ref(false)
const errorMessage = ref('')
const title = ref('')
const contentHtml = ref('')

/**
 * @param {string} code
 */
export async function openAgreement(code) {
  const nextCode = String(code || '').trim()
  if (!nextCode) return
  visible.value = true
  loading.value = true
  errorMessage.value = ''
  title.value = ''
  contentHtml.value = ''
  try {
    const data = await fetchAgreementDetailApi({ code: nextCode })
    title.value = data?.title || '协议'
    contentHtml.value = sanitizeAgreementHtml(data?.content || '')
  } catch (err) {
    errorMessage.value = err instanceof Error && err.message ? err.message : '协议暂不可用'
  } finally {
    loading.value = false
  }
}

export function closeAgreement() {
  visible.value = false
  loading.value = false
  errorMessage.value = ''
  title.value = ''
  contentHtml.value = ''
}

registerAgreementOpener(openAgreement)

export function useAgreement() {
  return {
    visible,
    loading,
    errorMessage,
    title,
    contentHtml,
    openAgreement,
    closeAgreement,
  }
}
